<template>
  <div
    :class="[
      'togglebtn',
      'js-togglebtn',
      { 'is-home': isHome() },
      { 'is-map': isMap() }
    ]"
  >
    <router-link :to="pathToGrandChildProp">
      <div
        :class="[
          'togglebtn__inner',
          '-mapbtn',
          'js-togglebtn_mapbtn',
          { 'is-active': isHome() }
        ]"
      >
        <span class="togglebtn__icon"><PinSVG></PinSVG></span>
        <span class="togglebtn__txt"
          >Map
          <div class="togglebtn__txt-bar -mapbtn"></div
        ></span>
      </div>
      <div
        :class="[
          'togglebtn__inner',
          '-gridbtn',
          'js-togglebtn_gridbtn',
          { 'is-active': isMap() }
        ]"
      >
        <span class="togglebtn__icon"><GridSVG></GridSVG></span>
        <span class="togglebtn__txt"
          >Grid
          <div class="togglebtn__txt-bar -gridbtn"></div
        ></span>
      </div>
    </router-link>
  </div>
</template>

<script>
import PinSVG from "./assets/pin.svg";
import GridSVG from "./assets/grid.svg";

export default {
  props: {
    pathToGrandChildProp: {
      type: String,
      default: ""
    }
  },
  components: {
    PinSVG,
    GridSVG
  },
  methods: {
    onClick(e) {
      // path書き換え
      // if (this.$route.path == "/") {
      //   this.$router.push("/map");
      // } else if (this.$route.path == "/map") {
      //   this.$router.push("/");
      // }
    },
    layout() {
      const lead = document.querySelector(".lead");

      const posGridX = window.innerWidth >= 768 ? 82 : 30;
      const posGridY = window.innerWidth >= 768 ? 34 : 17;

      const btn = document.querySelector(".js-togglebtn");
      const top =
        this.$route.path == "/"
          ? lead.getBoundingClientRect().top + window.scrollY
          : posGridY;
      const left =
        this.$route.path == "/"
          ? lead.getBoundingClientRect().left + lead.clientWidth + 50
          : posGridX;

      btn.style.top = `${top}px`;
      btn.style.left = `${left}px`;
    },
    isHome() {
      return this.$route.path == "/";
    },
    isMap() {
      return this.$route.path == "/map";
    }
  },
  mounted() {
    this.layout(); // 一旦ざっくりレイアウト
    window.addEventListener("load", this.layout); // ガタついた後のtopをもう一回レイアウト
    window.addEventListener("resize", this.layout);

    // タグが表示されたタイミングでもう一回レイアウト
    this.$store.watch(
      (state, getters) => getters.isLoadCategoryData,
      (newValue, oldValue) => {
        this.layout();
      }
    );
  },
  beforeDestroy: function() {
    window.removeEventListener("resize", this.layout);
  }
};
</script>

<style lang="scss" scoped>
.togglebtn {
  position: absolute;
  z-index: 1;

  a {
    position: relative;
    display: block;

    @include min(769) {
      &:hover {
        .togglebtn__txt-bar {
          transform-origin: left;
          transform: scaleX(1);
        }
      }
    }
  }

  &__txt {
    font-weight: 700;
    font-size: 16px;
    position: relative;

    &-bar {
      display: block;
      width: 100%;
      left: 0;
      bottom: 0;
      height: 1px;

      position: absolute;
      transform-origin: right;
      transform: scaleX(0);
      transition: transform 0.5s $easeOutExpo;

      &.-mapbtn {
        background: #707070;
      }
      &.-gridbtn {
        background: #fff;
      }
    }
  }

  &__icon {
    margin-right: 8px;
  }

  // &.is-home {
  //   top: 260px;
  //   left: 164px;
  // }

  // &.is-map {
  //   top: 34px;
  //   left: 82px;
  // }
}

.togglebtn__inner {
  display: flex;
  align-items: center;
  opacity: 0;

  &.-mapbtn {
    .togglebtn__txt {
      color: #000;
    }

    &.is-active {
      opacity: 1;
    }
  }

  &.-gridbtn {
    position: absolute;
    top: 0;
    left: 0;

    .togglebtn__txt {
      color: #fff;
    }

    &.is-active {
      opacity: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Common/Lead/ToggleBtn/_index.vue